import { pb } from '@q6cyber/proto2es';

export const DEFAULT_TEAM: pb.auth.AuthTeam = new pb.auth.AuthTeam();

export const DEFAULT_USER: pb.auth.AuthMember = new pb.auth.AuthMember();
